import React, { createContext, useCallback, useContext, useState } from 'react';

const LLMProcessContext = createContext();
export const useLLMProcess = () => useContext(LLMProcessContext);

export const LLM_STATES = {
    config: 'config',
    running: 'running',
    done: 'done',
    error: 'error',
    idle: 'idle',
};

/*
 *  status: idle | config | running | done | error
 */
export function LLMProcessProvider({ children }) {
    const [selected, setSelected] = useState([]);   // [{_id,title}]
    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState(LLM_STATES.idle);
    const [resultUrl, setResultUrl] = useState(null);
    const [resultMarkdown, setResultMarkdown] = useState(null);

    /** SideNavigation registers the job handler called by the prompt panel. */
    const [startProcess, setStartProcess] = useState(() => () => { });

    const reset = useCallback(() => {
        setSelected([]);
        setProgress(0);
        setResultUrl(null);
        setStatus(LLM_STATES.idle);
    }, []);

    return (
        <LLMProcessContext.Provider value={{
            /* nur Daten, die auch mehrere Komponenten brauchen */
            selected, setSelected,
            progress, setProgress,
            status, setStatus,
            resultUrl, setResultUrl,
            resultMarkdown, setResultMarkdown,
            startProcess, setStartProcess,
            reset,
        }}>
            {children}
        </LLMProcessContext.Provider>
    );
}
